import styled from 'styled-components';
import { breakPoints, colors } from '@/styles';

export const Modal = styled.div`
  position: relative;
  background: ${colors.primary.white};
  /* color: #000; */

  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  /* z-index: 1; */
  min-width: 400px;
  max-width: 600px;

  & > * {
    padding: 1rem 2rem;
  }

  & > .header {
    position: relative;
    padding-bottom: 1.2em;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    padding: 10px 2rem;
    border-bottom: 1px solid ${colors.secondary.lightGray3};
  }

  form {
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    /* justify-content: center; */
    width: 100%;
    gap: 1rem;

    /* flex: 0; */
  }

  @media (max-width: ${breakPoints.mobile}) {
    position: fixed;
    border-radius: 0;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    padding: 80px 20px 0;
  }
`;

export const ModalClose = styled.div`
  position: absolute;
  right: 10px;
  /* top: 20px; */
  cursor: pointer;
  &:hover {
    stroke-width: 2px;
  }
`;
